import React from 'react';
import classnames from 'classnames';
import { Icon } from 'antd';
import { WorldPin } from 'common/components/svgs';

export default function BudgetFriendlyPrivacy({ originalPriceTip, t, setEditVisible }) {
  const { cnPriceTip, rowPriceTip } = originalPriceTip;

  const handleOpenEditModal = () => {
    setEditVisible(true);
  };

  return (
    <div className="bfp-wrapper">
      <div className="label">
        {t('cms.dashboard.strategy.module_setting.budgetFriendlyPrivacy')}
      </div>
      <div className="right-wrapper nopadding">
        <p className="notice">{t('cms.dashboard.strategy.homepage_setting.tips')}</p>
        <div className="tip-wrapper">
          <div className="tip-row">
            <span className="tip-title">
              {t('cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.edit_tip')}
            </span>
            <div className="edit-wrapper" onClick={handleOpenEditModal}>
              <Icon type="edit" className="edit-svg" />
              <span className="edit">
                {t('cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.edit')}
              </span>
            </div>
          </div>
          <div className="tip-content-wrapper">
            <div className="tip-content-left">
              <div className="label">
                <WorldPin className="icon" />
                {t('cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.cn')}
              </div>
              <div className={classnames('content', !cnPriceTip?.tipContent && 'empty-content')}>
                {cnPriceTip?.tipContent
                  ? cnPriceTip?.tipContent
                  : t(
                      'cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.empty_content',
                    )}
              </div>
            </div>
            <div className={classnames(cnPriceTip?.enabled ? 'published' : 'unpublished')}>
              {t(
                `cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.${
                  cnPriceTip?.enabled ? 'published' : 'unpublished'
                }`,
              )}
            </div>
          </div>
          <div className="tip-content-wrapper">
            <div className="tip-content-left">
              <div className="label">
                <WorldPin className="icon" />
                {t('cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.row')}
              </div>
              <div className={classnames('content', !rowPriceTip?.tipContent && 'empty-content')}>
                {rowPriceTip?.tipContent
                  ? rowPriceTip?.tipContent
                  : t(
                      'cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.empty_content',
                    )}
              </div>
            </div>
            <div className={classnames(rowPriceTip?.enabled ? 'published' : 'unpublished')}>
              {t(
                `cms.dashboard.strategy.homepage_setting.budgetFriendlyPrivacy.${
                  rowPriceTip?.enabled ? 'published' : 'unpublished'
                }`,
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
